import axios from 'axios';
import { enhanceAxiosErrorMessage } from './enhanceAxiosErrorMessage';
import { getMessage } from './getMessage';

export const UNAUTHORISED = 'Unauthorised';

interface Props {
  message: string;
  name?: string;
  cause?: Error;
}

export class ImmersveError extends Error {
  cause?: Error;

  constructor(props: Props) {
    super(props.message);
    this.name = props.name || 'ImmersveError';
    this.cause = props.cause;
  }

  static create({
    name,
    message,
    cause,
  }: {
    name: string;
    message?: string;
    cause?: Error;
  }): ImmersveError {
    return new ImmersveError({ name, message: message || name, cause });
  }

  static fromCause({ name, cause }: { name: string; cause: Error }): ImmersveError {
    const message = axios.isAxiosError(cause) ? enhanceAxiosErrorMessage(cause) : getMessage(cause);
    return ImmersveError.create({ name, message, cause });
  }

  static unauthorised({ cause }: { cause: Error }): ImmersveError {
    return ImmersveError.fromCause({ name: UNAUTHORISED, cause });
  }

  static isUnauthorised(error: unknown): error is ImmersveError {
    return error instanceof ImmersveError && error.name === UNAUTHORISED;
  }
}
